import React from 'react';
import { StyleSheet, Text, TextInput, View } from '../base_components';

import { BusyComponent, BusyOverlay } from '../busy_component';
import Overlay from './overlay';
import TextButton from '../buttons/text_button';

import MediaIngest from '../../lib/media_ingest';

const styles = StyleSheet.create({
  uploaderSettingsOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  dialog: {
    padding: '3em',
    width: 'auto',
    minWidth: '20em',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  title: {
    marginTop: '0.5em',
    marginBottom: '0.5em',
    color: 'black',
    fontSize: '1.8em',
    fontWeight: 'bold',
  },
  line: {
    marginTop: '0.5em',
    marginBottom: '0.5em',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  label: {
    width: '12em',
    color: 'black',
    fontSize: '1.2em',
  },
  value: {
    color: '#333',
    fontSize: '1.2em',
  },
  input: {
    width: '10em',
    height: '2em',
    paddingLeft: '0.5em',
    paddingRight: '0.5em',
    backgroundColor: '#ccc',
    borderWidth: 1,
    borderColor: '#aaa',
    borderRadius: '0.3em',
  },
  button: {
    marginTop: '2em',
    height: '3em',
  },
  buttonView: {
    alignSelf: 'stretch',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

type Props = {
  onDone: () => void;
};
type State = {
  inflight_count: number;
  upload_limit: number;
};
export default class UploaderSettingsOverlay extends BusyComponent<
  Props,
  State
> {
  state = MediaIngest.getSettings();
  _onSave = () => {
    const { inflight_count, upload_limit } = this.state;
    MediaIngest.saveSettings({
      inflight_count: parseInt(inflight_count),
      upload_limit: parseInt(upload_limit),
    });
    window.alert('Saved');
  };
  _onInflightChange = (inflight_count) => this.setState({ inflight_count });
  _onUploadChange = (upload_limit) => this.setState({ upload_limit });
  render() {
    const { onDone } = this.props;
    const { inflight_count, upload_limit } = this.state;

    return (
      <View style={styles.uploaderSettingsOverlay}>
        <Overlay dialogStyle={styles.dialog} onClose={onDone}>
          <Text style={styles.title}>Uploader Settings</Text>
          <View style={styles.line}>
            <Text style={styles.label}>File Parallel Limit</Text>
            <TextInput
              style={styles.input}
              value={String(upload_limit)}
              type='number'
              onChangeText={this._onUploadChange}
            />
          </View>
          <View style={styles.line}>
            <Text style={styles.label}>Chunk Parallel Limit</Text>
            <TextInput
              style={styles.input}
              value={String(inflight_count)}
              type='number'
              onChangeText={this._onInflightChange}
            />
          </View>
          <TextButton
            style={styles.button}
            text='Save'
            onPress={this._onSave}
          />
        </Overlay>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}
